import React, { Component } from "react";
import { connect } from "react-redux";
import produce from "immer";
import { sessionAdd } from "../../actions/sessionActions";

class Add extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sessionInput: ""
    };
  }

  handleChange = e => {
    const { value, name } = e.target;
    this.setState(
      produce(draft => {
        draft[name] = value;
      })
    );
  };

  handleSubmit = e => {
    e.preventDefault();
    const { sessionInput } = this.state;
    console.log("submit");
    this.props.sessionAdd(sessionInput);
    this.setState(
      produce(draft => {
        draft.sessionInput = "";
      })
    );
  };

  render() {
    const { sessionInput } = this.state;
    return (
      <div className="row">
        <div className="col-12 text-center">
          <p>세션을 시작합니다.</p>
        </div>
        <div className="col-12 d-flex justify-content-center">
          <form
            onSubmit={this.handleSubmit}
            style={{ maxWidth: 500 }}
            className="d-flex"
          >
            <input
              type="text"
              className="mr-3"
              name="sessionInput"
              value={sessionInput}
              onChange={this.handleChange}
            />
            <button type="submit" className="btn btn-primary">
              세션 추가
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  { sessionAdd }
)(Add);
